import { PolymerElement, html } from '@polymer/polymer';
import '@polymer/polymer/polymer-legacy.js';
import './style/com-avl-cal-awakening-information-style.js';

import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@polymer/polymer/lib/elements/dom-if.js';

import '@com/icon';
import '@com/html';

class COMAvlCalAwakeningInformation extends PolymerElement {
    static get template() {
        return html`
            <style include="com-theme"></style>
            <style include="com-avl-cal-awakening-information-style"></style>

            <template is="dom-if" if="[[showAIComponent]]">
                <h2>
                    <com-html id="title" value="[[title]]"></com-html>
                </h2>
                <div id="parkAvailabilityContainer">
                    <template is="dom-repeat" items="[[availableParks]]" as="park">
                        <div class$="[[park.class]]">
                            <com-icon
                                aria-label$="[[_getLabelIconValue(park.available, park.parkName, park.availLabel, park.unavailLabel)]]"
                                value$="[[_getAvailabilityIconValue(park.available)]]"
                            ></com-icon>
                            <span>[[park.parkName]]</span>
                        </div>
                    </template>
                </div>
            </template>
            <com-html id="disclaimer" value="[[disclaimer]]"></com-html>
        `;
    }

    static get is() { return 'com-avl-cal-awakening-information'; }

    static get properties() {
        return {
            title: {
                type: String,
                value: ''
            },
            availableParks: {
                type: Array,
                value: []
            },
            showAIComponent: {
                type: Boolean,
                value: true
            }
        };
    }

    ready() {
        super.ready();
    }

    /**
     * Gets the available/unavailable icon depending on the park status
     * @param isParkAvailable
     * @return {string}
     * @private
     */
    _getAvailabilityIconValue(isParkAvailable) {
        return isParkAvailable ? '&#57921;' : '&#57946;';
    }

    /**
     * Gets the available/unavailable label depending on the park status
     * @param isParkAvailable
     * @param parkName
     * @param availLabel
     * @param unavailLabel
     * @return {string}
     * @private
     */
    _getLabelIconValue(isParkAvailable, parkName, availLabel, unavailLabel) {
        return isParkAvailable
            ? parkName + ' ' + availLabel
            : parkName + ' ' + unavailLabel;
    }

}
customElements.define(COMAvlCalAwakeningInformation.is, COMAvlCalAwakeningInformation);
